// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QiPDe","buttons":"styles_buttons__12RKr"};